import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/phoneTemplateWithImageStyles';
import IosPreviewNotificationWithImage from 'assets/img/previews/Preview_iOS_Notification_Image.png';
import AndroidPreviewNotificationWithImage from 'assets/img/previews/Preview_Android_Notification_Image.png';

class PhoneNotificationPreviewWithImage extends Component {
	render() {
		const { classes, text, image, type, notificationTitle } = this.props;
		const classNames = {};
		let templateImage;
		let platformName;

		if (type === 'ios') {
			classNames.notificationTitle = [classes.notificationText, classes.iosNotificationTitle].join(' ');
			classNames.notificationText = [classes.notificationText, classes.iosNotificationText].join(' ');
			classNames.notificationImage = [classes.notificationImage, classes.iosNotificationImage].join(' ');
			classNames.template = classes.iosTemplate;
			templateImage = IosPreviewNotificationWithImage;
			platformName = 'iOS';
		} else {
			classNames.notificationTitle = [classes.notificationText, classes.androidNotificationTitle].join(' ');
			classNames.notificationText = [classes.notificationText, classes.androidNotificationText].join(' ');
			classNames.notificationImage = [classes.notificationImage, classes.androidNotificationImage].join(' ');
			classNames.template = classes.androidTemplate;
			templateImage = AndroidPreviewNotificationWithImage;
			platformName = 'Android';
		}

		return (
			<div className={classes.wrapper}>
				<div className={classes.platformName}>{platformName}</div>
				<img
					className={classNames.template}
					src={templateImage}
					alt="Preview NotificationWith"
				/>
				{text && <div className={classNames.notificationTitle}>
					{notificationTitle}
				</div>}
				<span className={classNames.notificationText}>
					{text}
				</span>
				{image && <img
					src={image}
					className={classNames.notificationImage}
					alt="Main"
				/>}
			</div>
		);
	}
}

PhoneNotificationPreviewWithImage.propTypes = {
	type: PropTypes.oneOf([
		'android',
		'ios',
	]).isRequired,
	classes: PropTypes.object.isRequired,
	notificationTitle: PropTypes.string,
	text: PropTypes.string,
	image: PropTypes.string,
};

export default withStyles(styles)(PhoneNotificationPreviewWithImage);
